import { gql } from '@apollo/client';

export const UploadEntityFieldsFragment = gql`
  fragment UploadEntityFields on UploadEntity {
    url
    objectKey
  }
`;

export const LlmConfigFieldsFragment = gql`
  fragment LlmConfigFields on LlmConfig {
    enabled
    projectId
    organizationId
    modelName
    assistantInstructions
    defaultAssistantInstructions
  }
`;

export const LlmChatMessageFieldsFragment = gql`
  fragment LlmChatMessageFields on LlmChatMessage {
    text
    attachments {
      llmFileId
      originalS3Key
    }
    sender
    createdAt
  }
`;

const LlmSummarySectionsFieldsFragment = gql`
  fragment LlmSummarySectionsFields on LlmSummarySections {
    executiveSummary
    keyInsights
    summaryStatistics
    recommendations
  }
`;

export const LlmSubjectSummaryFieldsFragment = gql`
  fragment LlmSubjectSummaryFields on LlmSubjectSummary {
    sections {
      ...LlmSummarySectionsFields
    }
    text
    richText
    updatedAt
  }
  ${LlmSummarySectionsFieldsFragment}
`;

export const LlmSummarizeResponseFieldsFragment = gql`
  fragment LlmSummarizeResponseFields on LlmSummarizeResponse {
    summary {
      ...LlmSubjectSummaryFields
    }
    error
    thread {
      ...LlmChatMessageFields
    }
  }
  ${LlmSubjectSummaryFieldsFragment}
  ${LlmChatMessageFieldsFragment}
`;

const LlmConversationUserPromptFieldsFragment = gql`
  fragment LlmConversationUserPromptFields on LlmConversationUserPrompt {
    id
    message
    abTestGroup
    createdAt
  }
`;

const LlmConversationResponseTextFieldsFragment = gql`
  fragment LlmConversationResponseTextFields on LlmConversationResponseText {
    id
    message
    abTestGroup
    responseTimeMs
    debugInfo
    createdAt
  }
`;

const LlmConversationResponseErrorFieldsFragment = gql`
  fragment LlmConversationResponseErrorFields on LlmConversationResponseError {
    id
    message
    abTestGroup
    responseTimeMs
    debugInfo
    createdAt
  }
`;

const LlmConversationResponseFormulaFieldsFragment = gql`
  fragment LlmConversationResponseFormulaFields on LlmConversationResponseFormula {
    id
    message
    queryType
    queryId
    queryDefinition
    abTestGroup
    responseTimeMs
    debugInfo
    createdAt
  }
`;

export const LlmConversationMessagesFieldsFragment = gql`
  fragment LlmConversationMessagesFields on LlmConversationMessages {
    list {
      ... on LlmConversationUserPrompt {
        ...LlmConversationUserPromptFields
      }
      ... on LlmConversationResponseText {
        ...LlmConversationResponseTextFields
      }
      ... on LlmConversationResponseError {
        ...LlmConversationResponseErrorFields
      }
      ... on LlmConversationResponseFormula {
        ...LlmConversationResponseFormulaFields
      }
    }
  }
  ${LlmConversationUserPromptFieldsFragment}
  ${LlmConversationResponseTextFieldsFragment}
  ${LlmConversationResponseErrorFieldsFragment}
  ${LlmConversationResponseFormulaFieldsFragment}
`;

export const LlmConversationFieldsFragment = gql`
  fragment LlmConversationFields on LlmConversation {
    schemaId
    messages {
      ...LlmConversationMessagesFields
    }
  }
  ${LlmConversationMessagesFieldsFragment}
`;
